import getAppliedGiftcards from '../../GiftCardSelectors/getAppliedGiftcards';
import {getSettings} from '../../selectors';

export default paymentOptionName => (state) => {
  const settings = getSettings(state);
  const appliedGiftcards = getAppliedGiftcards(state);
  if (appliedGiftcards.length > 0) {
    const allowedOptionsforGiftcard = settings?.allowed_payment_methods_with_applied_giftcards;
    if (allowedOptionsforGiftcard && allowedOptionsforGiftcard.length) {
      return !allowedOptionsforGiftcard.includes(paymentOptionName);
    }
  }
  return false;
};
